var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('add-to-cal',{attrs:{"title":_vm.$parent.event.name,"startep":_vm.$parent.event.startep,"endep":_vm.$parent.event.endep,"descr":_vm.$parent.event.descr,"url":_vm.get_event_url(_vm.$parent.event),"nopop":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }